import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ApiService } from '../services/api.service';
import { PendingInventoryComponent } from './pending-inventory.component';

interface Product {
  id: number;
  name?: string;
  description?: string;
  catalogNum?: string;
  lotNum?: string;
  qBO_Product_Id?: number;
  vendorProductId?: number;
}

@Component({
  standalone: true,
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrl: './products.component.css',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    MatFormFieldModule,
    PendingInventoryComponent
  ]
})
export class ProductsComponent implements OnInit {
  dataSource = new MatTableDataSource<Product>([]);
  displayedColumns: string[] = ['name', 'description', 'catalogNum', 'lotNum'];
  loading: boolean = true;
  error: string | null = null;

  @ViewChild(MatSort) set matSort(s: MatSort) {
    if (s) { this.dataSource.sort = s; }
  }

  @ViewChild(MatPaginator) set matPaginator(p: MatPaginator) {
    if (p) { this.dataSource.paginator = p; }
  }

  constructor(
    private router: Router,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadProducts();
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  loadProducts(): void {
    this.loading = true;
    this.error = null;

    console.log('Loading products from API...');
    console.log('Current products in dataSource:', this.dataSource.data);

    this.apiService.get<any>('product/all').subscribe({
      next: (data) => {
        console.log('API Response received:', data);
        console.log('Response type:', typeof data);
        console.log('Is Array?', Array.isArray(data));
        console.log('Response keys:', data ? Object.keys(data) : 'null');

        // Handle if data is wrapped in an object
        let productsArray: any[];
        if (Array.isArray(data)) {
          productsArray = data;
        } else if (data && data.products) {
          productsArray = data.products;
        } else if (data && data.data) {
          productsArray = data.data;
        } else if (data && data.value) {
          productsArray = data.value;
        } else {
          console.error('Unexpected response format:', data);
          productsArray = [];
        }

        console.log('Products array to display:', productsArray);
        console.log('Number of products:', productsArray.length);

        // Map the response to handle both camelCase and PascalCase
        const products = productsArray.map(p => ({
          id: p.id || p.Id,
          name: p.name || p.Name,
          description: p.description || p.Description,
          catalogNum: p.catalogNum || p.CatalogNum,
          lotNum: p.lotNum || p.LotNum,
          qBO_Product_Id: p.qBO_Product_Id || p.QBO_Product_Id,
          vendorProductId: p.vendorProductId || p.VendorProductId
        }));

        this.dataSource.data = products;
        this.loading = false;
        console.log('Products loaded into table:', products);
        console.log('Products count:', products.length);
        console.log('Loading flag after data load:', this.loading);

        // Force change detection
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error loading products:', err);
        console.error('Error status:', err.status);
        console.error('Error message:', err.message);
        console.error('Full error:', err);

        if (err.status === 0) {
          this.error = 'Cannot connect to API. Make sure the Web API is running on https://localhost:44392 and SSL certificate is trusted.';
        } else if (err.status === 401) {
          this.error = 'Unauthorized. Please log out and log in again.';
        } else if (err.status === 404) {
          this.error = 'API endpoint not found. Check the API URL and endpoint.';
        } else {
          this.error = `Failed to load products: ${err.message || 'Unknown error'}`;
        }

        this.loading = false;
        console.log('Loading flag after error:', this.loading);

        // Force change detection
        this.cdr.detectChanges();
      }
    });
  }

  createNewProduct(): void {
    this.router.navigate(['/products/new']);
  }

  viewProduct(product: Product): void {
    this.router.navigate(['/products', product.id]);
  }

  editProduct(product: Product): void {
    this.router.navigate(['/products', product.id]);
  }
}
